<!-- 资金管理-扣除記錄 -->
<template>
  <div>
    <page :url="url" :form="form" @reset="reset">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.merchantName')">
          <el-select
              v-model="form.appId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
          >
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.orderNumber')">
          <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              :range-separator="$t('text.to')"
              :start-placeholder="$t('text.startDate')"
              :end-placeholder="$t('text.endDate')"
              @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
      </template>

      <template slot="tableColumn">

        <el-table-column
            width="200"
            prop="id"
            :label="$t('text.reductionRecordId')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="250"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="180"
            prop="appId"
            :label="$t('text.appId')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="160"
            prop="merchantName"
            :label="$t('text.merchantName')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="orderAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.orderAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="currentBalance"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.afterBalance')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="createTimeFormat"
            :label="$t('text.creationTime')"
            align="center"
        ></el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page
  },
  props: {
    fromMerchantList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      url: "/creditDeductionRecord/selectList",
      action: "",
      timeDate: [],
      form: {
        appId: "",
        status: "",
        orderId: "",
        startDate: "",
        endDate: "",
      },
      merchantList: [],
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
watch: {
  fromMerchantList() {
    this.merchantList = this.fromMerchantList;
    if (this.merchantList.length === 1) {
      this.form.appId = this.merchantList[0].value;
      this.$bus.$emit("refresh");
    }
  }
}
};
</script>
